// eslint-disable-next-line no-unused-vars
import React, { useContext, useState } from "react";
import ReportTemplate from "./ReportTemplate";
import SecureLS from "secure-ls";
import { NavigationContext } from "navigation-react";
import useSWR from "swr";
import LoaderAnimation from "./LoaderAnimationLarge";

const ls = new SecureLS({ encodingType: "aes" });
const usercsrf_token = ls.get("usercsrf_token");

const fetcher = (url) =>
  fetch(url, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": usercsrf_token,
    },
  }).then((res) => res.json());

const ViewCTScanRequestRegister = () => {
  const { data } = useContext(NavigationContext);

  const {
    data: requestData,
    error: requestDataError,
    isLoading: requestDataLoading,
  } = useSWR(data && `/node/${data?.nid}?_format=json`, fetcher);

  const {
    data: requesterData,
    error: requesterDataError,
    isLoading: requesterDataLoading,
  } = useSWR(data && `${requestData?.uid?.[0]?.url}?_format=json`, fetcher);
  // console.log("requesterData", requesterData);

  const {
    data: patientData,
    error: patientDataError,
    isLoading: patientDataLoading,
  } = useSWR(
    requestData &&
      `${requestData?.field_ctscan_request_patient_id?.[0]?.url}?_format=json`,
    fetcher
  );

  const {
    data: reportData,
    error: reportDataError,
    isLoading: reportDataLoading,
  } = useSWR(
    requestData &&
      `/node/${requestData?.field_ctscan_report_id?.[0]?.target_id}?_format=json`,
    fetcher
  );
  // console.log("reportData", reportData);

  const {
    data: reporterData,
    error: reporterDataError,
    isLoading: reporterDataLoading,
  } = useSWR(
    reportData && `${reportData?.uid?.[0]?.url}?_format=json`,
    fetcher
  );
  // console.log("reporterData", reporterData);

  const {
    data: investigationsData,
    error: investigationsDataError,
    isLoading: investigationsDataLoading,
  } = useSWR(
    requestData &&
      `${requestData?.field_request_reference_investig?.[0]?.url}?_format=json`,
    fetcher
  );

  if (
    reportDataError ||
    requestDataError ||
    patientDataError ||
    investigationsDataError ||
    reporterDataError ||
    requesterDataError
  ) {
    return (
      <LoaderAnimation loadingTxt="Network error. Please refresh and try again" />
    );
  }

  if (
    reportDataLoading ||
    requestDataLoading ||
    patientDataLoading ||
    investigationsDataLoading ||
    reporterDataLoading ||
    requesterDataLoading
  ) {
    return <LoaderAnimation loadingTxt="Viewing report..." />;
  }

  return (
    <>
      <ReportTemplate
        patientDataTitle={patientData?.title?.[0]?.value || "N/A"}
        patientDataDateOfBirth={
          patientData?.field_date_of_birth?.[0]?.value || "N/A"
        }
        patientDataGender={patientData?.field_gender?.[0]?.value || "N/A"}
        patientDataPatientID={
          patientData?.field_patient_id?.[0]?.value || "N/A"
        }
        referededBy={requesterData?.field_doctor_referer_full_name?.[0]?.value}
        reportUUID={
          reportData?.uuid?.[0]?.value?.slice(0, 23).toUpperCase() || "N/A"
        }
        requestDataCreated={requestData?.created?.[0]?.value || "N/A"}
        reportDataCreated={reporterData?.created?.[0]?.value || "N/A"}
        investigationsDataTitle={investigationsData?.title?.[0]?.value || "N/A"}
        requestDataFieldClinicalDiagnosis={
          requestData?.field_ct_scan_clinical_diagnosis?.[0]?.value || "N/A"
        }
        requestDataFieldComments={
          requestData?.field_ct_scan_comments?.[0]?.value || "N/A"
        }
        reportDataTitle={
          reportDataLoading ? (
            <LoaderAnimation loadingTxt="Loading..." />
          ) : (
            reportData?.title?.[0]?.value || "Report"
          )
        }
        reportDataFieldReportTechnique={
          reportData?.field_ct_scan_report_technique?.[0]?.value
        }
        reportDataFieldReportFindings={
          reportData?.field_ct_scan_report_findings?.[0]?.value
        }
        reportDataFieldReportImpression={
          reportData?.field_ct_scan_report_impression?.[0]?.value
        }
        reporterDataFieldDoctorRefererfullname={
          reporterData?.field_doctor_referer_full_name?.[0]?.value
        }
        reporterDataFieldSpecialty={reporterData?.field_specialty?.[0]?.value}
        noreportMessage={
          "Your report is currently being uploaded; thank you for waiting."
        }
      />
    </>
  );
};

export default ViewCTScanRequestRegister;
